<template>
  <div class="right">
    <div class="field_left">
      <checkbox-input
          id="streamprofiledefaultconfiguration"
          v-model="isDefaultConfiguration"
          ref="defaulconfigurationref"
          :disabled="disabled"
      >
        <translate class="translate">Použít výchozí konfiguraci</translate>
      </checkbox-input>
    </div>
    <div class="field_left">
      <checkbox-input
          id="streamprofilemuxmaskaudio"
          v-model="muxMask.a"
          ref="muxmaskaudioref"
          @input="createMuxMaskFromSelection"
          :disabled="!subSelectIsEditable"
      >
        <translate class="translate">Audio (a)</translate>
      </checkbox-input>
    </div>
    <div class="field_right">
      <checkbox-input
          id="streamprofilemuxmaskseparateaudio"
          v-model="muxMask.A"
          @input="createMuxMaskFromSelection"
          ref="muxmaskseparateaudioref"
          :disabled="!subSelectIsEditable"
      >
        <translate class="translate">Oddělit audio stopy (A)</translate>
      </checkbox-input>
    </div>
    <div class="field_left">
      <checkbox-input
          id="streamprofilemuxmaskvideo"
          v-model="muxMask.v"
          @input="createMuxMaskFromSelection"
          ref="muxmaskvideoref"
          :disabled="!subSelectIsEditable"
      >
        <translate class="translate">Video (v)</translate>
      </checkbox-input>
    </div>
    <div class="field_right">
      <checkbox-input
          id="streamprofilemuxmaskdvbsubonly"
          v-model="muxMask.T"
          @input="createMuxMaskFromSelection"
          ref="muxmaskdvbsubonlyref"
          :disabled="!subselectSubtitlesIsEditable"
      >
        <translate class="translate">Pouze dvb_sub titulky (T)</translate>
      </checkbox-input>
    </div>
    <div class="field_left">
      <checkbox-input
          id="streamprofilemuxmasksubtitles"
          v-model="muxMask.s"
          @input="createMuxMaskFromSelection"
          ref="muxmasksubtitlesref"
          :disabled="!subSelectIsEditable"
      >
        <translate class="translate">Titulky (s)</translate>
      </checkbox-input>
    </div>
    <div class="field_right">
      <checkbox-input
          id="streamprofilemuxmaskseparatesub"
          v-model="muxMask.S"
          @input="createMuxMaskFromSelection"
          ref="muxmaskseparatesubref"
          :disabled="!subSelectIsEditable"
      >
        <translate class="translate">Oddělit titulkové stopy (S)</translate>
      </checkbox-input>
    </div>
    <div class="field_left">
      <checkbox-input
          id="streamprofilemuxmaskteletext"
          v-model="muxMask.t"
          ref="muxmaskteletextref"
          @input="createMuxMaskFromSelection"
          :disabled="!subSelectIsEditable"
      >
        <translate class="translate">Teletext (t)</translate>
      </checkbox-input>
    </div>
    <div class="field_right">
      <checkbox-input
          id="streamprofilemuxmaskfirstaudiotrackonly"
          v-model="muxMask.F"
          @input="createMuxMaskFromSelection"
          ref="muxmaskfirstaudiotrackonlyref"
          :disabled="!subselectFirstAudioTrackOnlyIsEditable"
      >
        <translate class="translate">Pouze první audiostopa (F)</translate>
      </checkbox-input>
    </div>
    <div class="field_left">
      <checkbox-input
          id="streamprofileshareextratracks"
          v-model="shareExtraTracks"
          ref="shareextratracksref"
          @input="createMuxMaskFromSelection"
          :disabled="!allowShareExtraTracks"
      >
        <translate class="translate">Sdílet oddělené stopy</translate>
      </checkbox-input>
    </div>
    <div class="field_left">
      <text-input id="streamProfilesyncgroup"
                  v-model="this.entity.mux_mask"
                  ref="syncgroupref"
                  :disabled="true"
      >
        <translate class="translate">Výsledná muxovací maska</translate>
      </text-input>
    </div>
    <div class="field_left">
      <checkbox-input
          id="streamprofileallowchangeaudiocodecs"
          v-model="allowChangeAudioCodecs"
          ref="llowchangeaudiocodecsref"
          :disabled="disabled"
      >
        <translate class="translate">Filtrovat audio kodeky</translate>
      </checkbox-input>
      <text-input id="streamprofileallowedaudiocodecs"
                  v-model="entity.allowed_audio_codecs"
                  ref="streamprofileallowedaudiocodecsref"
                  :disabled="!allowChangeAudioCodecs"
                  :help-text="$gettext('Seznam id kodeků knihovny avlib oddělených čárkami (např. aac,ac3,mp2)')"
      >
        <translate class="translate">Seznam audio kodeků</translate>
      </text-input>
    </div>
  </div>

</template>

<script>
export default {
  name: "StreamProfileMuxMask",
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  data: function () {
    return {
      muxMask: {
        "a": false,
        "v": false,
        "s": false,
        "A": false,
        "T": false,
        "S": false,
        "F": false,
        "t": false,
      },
      shareExtraTracks: false,
      muxMaskString: "",
    };
  },
  computed: {
    disabled(){
      return !this.isEditable || !this.$_updateActionAllowed;
    },
    isDefaultConfiguration: {
      get() {
        return this.entity.mux_mask === null;
      },
      set(value) {
        if (value) {
          this.resetMuxMaskSelection();
          this.entity.mux_mask = null;
        } else {
          this.entity.mux_mask = "";
        }
      }
    },
    allowChangeAudioCodecs: {
      get() {
        return this.entity.allowed_audio_codecs !== null && !this.disabled;
      },
      set(value) {
        if (value) {
          this.entity.allowed_audio_codecs = "";
        } else {
          this.entity.allowed_audio_codecs = null;
        }
      }
    },

    subselectSubtitlesIsEditable() {
      return this.isEditable && this.muxMask.s && this.$_updateActionAllowed;
    },

    subselectFirstAudioTrackOnlyIsEditable() {
      return this.isEditable && this.muxMask.a && this.$_updateActionAllowed;
    },

    subSelectIsEditable() {
      return this.isEditable && !this.isDefaultConfiguration && this.$_updateActionAllowed;
    },

    allowShareExtraTracks(){
      let allow = this.muxMask.A || this.muxMask.S;
      if(!allow){
        this.shareExtraTracks = false;
      }
      return allow && this.isEditable && this.$_updateActionAllowed;
    }
  },
  methods: {
    resetMuxMaskSelection() {
      for (let key in this.muxMask) {
        this.muxMask[key] = false;
      }
      this.entity.share_extra_tracks = false;
    },
    createMuxMaskFromSelection() {
      if (!this.muxMask.a) {
        this.muxMask.F = false;
      }

      if (!this.muxMask.s) {
        this.muxMask.T = false;
      }

      if (this.muxMask.t){
        this.muxMask.T = false;
      }

      let mask = "";
      for (let key in this.muxMask) {
        if (this.muxMask[key]) {
          mask += key;
        }
      }
      this.entity.mux_mask = mask;
      this.entity.share_extra_tracks = this.shareExtraTracks;
    },
    createSelectionFromMuxMask() {
      let shareExtraTracks = this.entity.share_extra_tracks;
      this.resetMuxMaskSelection();
      for (let i = 0; i < this.entity.mux_mask.length; i++) {
        let key = this.entity.mux_mask[i];
        if (this.muxMask.hasOwnProperty(key)) {
          this.muxMask[key] = true;
        } else {
          console.error("Unknown mux mask character: " + key);
        }
      }
      this.shareExtraTracks = shareExtraTracks;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/streamProfiles/forms/StreamProfileMuxMask.vue